import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";

type ResetPasswordInput = { tenantSlug: string; token: string; new_password: string };
type ResetPasswordResponse = { message: string };

export function useResetPassword() {
  return useMutation<ResetPasswordResponse, ApiError, ResetPasswordInput>({
    mutationFn: async ({ tenantSlug, token, new_password }) => {
      // fix/auth-slug-in-url: slug rides in the URL for client-routing symmetry
      // with /api/t/{slug}/auth/login. The reset token is user-bound, so the
      // slug is not used to scope the lookup.
      const resp = await apiClient.post<ResetPasswordResponse>(
        `/api/t/${encodeURIComponent(tenantSlug)}/auth/reset-password`,
        { token, new_password },
      );
      return resp.data;
    },
  });
}
